import React from 'react'
import DefaultLink from '../../../components/DefaultLink'

export default function IndustryServe({data}) {
  return (
    <>
      <section className="industry-serve-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3 className="heading center-heading">{data?.head}</h3>
            </div>

            {data?.boxes?.map((item, index)=>(
              <div className="col-md-6" key={index}>
                <div className="industry-serve-box">
                  <img src={item?.img} alt="Industry" />
                  <span>{item?.title}</span>
                  <p>{item?.desc}</p>
                  <DefaultLink to={item?.slug} text={item?.btnText} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
